module.exports = __webpack_public_path__ + "img/chantier-maison.fbc2c535.jpg";